/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Heading, Box } from '@deckee/deck-hand';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const HeaderBarItem = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

// @ts-ignore
const HeaderBarItemCenter = styled(HeaderBarItem)`
  display: flex;
  align-items: center;
  /* justify-content: center; */
  overflow: hidden;

  /* Allow the center node to shink but not grow, allowing for the left and right to
grow as much as possible. Setting a min-width of 0 allows for the HeaderBarHeading ellipsis 
to work */
  min-width: 0;
  flex: 0 1 auto;
`;

// @ts-ignore
const HeaderBarItemLeft = styled(HeaderBarItem)<{ wrapText?: boolean }>`
  padding-left: 10px;
  padding-right: 10px;
  white-space: ${({ wrapText }) => (wrapText ? 'normal' : 'nowrap')};
  text-overflow: ${({ wrapText }) => (wrapText ? 'clip' : 'ellipsis')};
  word-wrap: ${({ wrapText }) => (wrapText ? 'break-word' : undefined)};
  word-break: ${({ wrapText }) => (wrapText ? 'break-word' : undefined)};
  flex: ${({ wrapText }) => (wrapText ? '1 1 0' : undefined)};
`;

// @ts-ignore
const HeaderBarItemRight = styled(HeaderBarItem)<{ flexShrink?: boolean }>`
  padding-left: 10px;
  padding-right: 10px;
  justify-content: flex-end;
  flex: ${({ flexShrink }) => (flexShrink ? '0 1 0' : undefined)};
`;

export const HeaderBarHeading = styled(Heading)`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.2em; // Fixes issue with g's having their tails cut off from when bold

  /* Hacked in colours to make it match the existing head bar, should be removed at some point */
  font-size: 18px;
`;

interface HeaderBarProps {
  centerNode?: ReactNode | string;
  leftNode?: ReactNode | string;
  rightNode?: ReactNode | string;
  className?: string;

  // This exists because by default the headerbar doesn't have a background and just uses the background of the parent. We have
  // some layouts (like sheets or location layout) don't have a background. So for consistancy, have added this prop to
  // apply a consistant background colour in these cases
  solidBackground?: boolean;
  popover?: boolean;
}

const HeaderBarWrapper = styled.div<HeaderBarProps>`
  display: flex;
  flex-wrap: wrap;
  min-height: 61px;
  align-items: center;

  ${({ solidBackground, theme }) =>
    solidBackground &&
    `
    background-color: ${theme.colors.white};
  `}

  pointer-events: all;
`;

const HeaderBar: FC<HeaderBarProps> = ({
  centerNode,
  leftNode,
  rightNode,
  className,
  solidBackground,
  children,
  popover,
}) => (
  <>
    <HeaderBarWrapper solidBackground={solidBackground} className={className}>
      <HeaderBarItemLeft wrapText={popover}>
        {leftNode &&
        (typeof leftNode === 'string' || leftNode instanceof String) ? (
          <HeaderBarHeading pl="2" level="5">
            {leftNode}
          </HeaderBarHeading>
        ) : (
          leftNode
        )}
      </HeaderBarItemLeft>

      <HeaderBarItemCenter>
        {centerNode &&
        (typeof centerNode === 'string' || centerNode instanceof String) ? (
          <HeaderBarHeading level="5">{centerNode}</HeaderBarHeading>
        ) : (
          centerNode
        )}
      </HeaderBarItemCenter>

      <HeaderBarItemRight flexShrink={popover}>{rightNode}</HeaderBarItemRight>
    </HeaderBarWrapper>
    {children && <Box width="100%">{children}</Box>}
  </>
);

HeaderBar.defaultProps = {
  centerNode: undefined,
  leftNode: undefined,
  rightNode: undefined,
  className: undefined,
  solidBackground: undefined,
  popover: false,
};

export default HeaderBar;
